module.exports = __webpack_public_path__ + "media/components/src/assets/images/method/credit-img-2ef906084812821ed5729104efb732f4.png";